import React from 'react';
import dynamic from 'next/dynamic';
import { Loader } from '@/components';
import { MetaData } from '@/containers';
import { fetchShops, getShopsData } from '@fh-components/fh-js-api-core/store/slices/shopsSlice';

const ReturnPolicyPage = dynamic(() => import('../../layouts/ReturnPolicyPage'), {
	loading: () => <Loader />,
});

const ReturnPolicy = ({ shops }) => {
	return (
		<>
			<MetaData
				title='Возврат товаров в интернет-магазине FH.BY'
				description='Условия возврата товара надлежащего и ненадлежащего качества в интернет-магазине FH.BY.'
			/>
			<ReturnPolicyPage shops={shops} />
		</>
	);
};

ReturnPolicy.getInitialProps = async ({ reduxStore }) => {
	await reduxStore.dispatch(fetchShops());

	const pageData = getShopsData(reduxStore.getState());

	return { shops: pageData?.data?.shops ?? [] };
};

export default ReturnPolicy;
